import {createSelector} from '@reduxjs/toolkit';

import {TAppState} from 'store/config/types';
import {AIS3_SLICE} from 'store/slices/ais-slice/ais-slice-constants';

const selectAisSliceState = (state: TAppState) => state[AIS3_SLICE];

export const selectTaxForecastsCommonData = createSelector(
    selectAisSliceState,
    ({taxForecasts}) => taxForecasts,
);

export const selectTaxForecastsTableData = createSelector(
    selectTaxForecastsCommonData,
    commonData => commonData?.tableData?.dataTable,
);

export const selectTaxForecastsFiltersData = createSelector(
    selectTaxForecastsCommonData,
    commonData => ({
        requestId: commonData?.requestId,
        status: commonData?.status,
        dateForecast: commonData?.dateForecast,
    }),
);
